import { get } from "../../utils/httpClient";

const activityLogService = () => {
  const prefixApi = "duedates/activitylogs";

  const getAllActivityLogs = async (taskId) => {
    return await get(`/${prefixApi}/task`, {
      taskId: taskId,
    });
  };

  const getActivityLog = async (id) => {
    return await get(`/${prefixApi}/${id}`);
  };

  const getFirstAndLastActivityLogs = async (taskId) => {
    return await get(`/${prefixApi}/firstandlast`, {
      taskId: taskId,
    });
  };

  return {
    getAllActivityLogs,
    getActivityLog,
    getFirstAndLastActivityLogs,
  };
};

export default activityLogService;
